import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";

import styles from "./SingleResult.module.scss";
import Modal from "../../components/Modal/Modal";
import UpsertPollModal from "../../components/Modal/UpsertPollModal";

interface Props {
    title: string,
    artist: string,
    image: string,
    file: string,
    content: string,
    id: number,
    pollId: string | undefined,
    numberOfVotes: number,
    percentOfVotes: number,
    trend: string,
    index: number
}

const ResultTable: React.FC<Props> = ({ title, artist, image, file, id, pollId, numberOfVotes, percentOfVotes, trend, index }) => {
    const [showModal, setShowModal] = useState<boolean>(false);


    const trendCheck = (num: string) => {
        if (num === null) {
            return (
                <div className={styles.trendingBox}>
                    <div className={styles.rankEqual}></div>
                    <p>0</p>
                </div>
            )
        } else if (num.charAt(0) === "-") {
            return (
                <div className={styles.trendingBox}>
                    <div className={styles.rankDown}></div>
                    <p>{num}</p>
                </div>
            )
        } else {
            return (
                <div className={styles.trendingBox}>
                    <div className={styles.rankUp}></div>
                    <p>{num}</p>
                </div>
            )
        }
    }

    return (
        <div className={styles.option}>
            <div className={styles.rankBox}>
                <p className={styles.place}>Miejsce</p>
                <h4 className={styles.ranking}>{index + 1}.</h4>
            </div>
            <div className={styles.leftSide}>
                <div className={styles.option__image}>
                    <img src={image} alt="obrazek opcji" width={200}></img>
                </div>
            </div>
            <div className={styles.rightSide}>
                <div className={styles.rightSideLeft}>
                    <div>
                        <div className={styles.option__artist}>
                            {artist}
                        </div>
                        <div className={styles.option__title}>
                            {title}
                        </div>
                    </div>
                    <div className={styles.option__file}>
                        {file ? (
                            <ReactPlayer
                                url={file}
                                controls={true}
                                height="70px"
                                width="380px"
                                config={{
                                    file: {
                                        forceAudio: true
                                    }
                                }}
                            />) : (
                            <p className={styles.noContentError}>Brak pliku mp3!</p>
                        )}
                    </div>
                </div>
                <div className={styles.rightSideRight}>
                    {trendCheck(trend)}
                    <div className={styles.votes}>
                        <div className={styles.voteIcon}></div>
                        {numberOfVotes} ({percentOfVotes}%)
                    </div>
                </div>
                <div className={styles.buttonsBox}>
                    <button
                        className={styles.btnEditResult}
                        onClick={(e) => {
                            e.preventDefault();
                            setShowModal(true);
                        }
                        }
                    >
                        Edytuj
                    </button>
                </div>
            </div>
            {showModal &&
                <Modal openModal={setShowModal}>
                    <UpsertPollModal openModal={setShowModal} pollId={pollId} optionId={id} numberOfVotes={numberOfVotes} />
                </Modal>
            }
        </div>
    )
}

export default ResultTable;